import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const CheapDexscreenerReactions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Cheap Dexscreener Reactions - Lowest Prices from $0.05 | Dexreaction</title>
        <meta name="description" content="Cheap Dexscreener Reactions from just $0.05! Buy affordable rockets 🚀, fire 🔥, poop 💩 reactions. Cheapest prices + 20% bonus FREE. Best value Dexscreener reaction service!" />
        <meta name="keywords" content="cheap dexscreener reactions, affordable dexscreener, cheap dexmoji, buy dexscreener reactions, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, cheapest dexscreener, budget dexscreener" />
        <link rel="canonical" href="https://dexreaction.com/cheap-dexscreener-reactions" />
        <meta property="og:title" content="Cheap Dexscreener Reactions - Best Prices | Dexreaction" />
        <meta property="og:description" content="Cheapest Dexscreener reactions from $0.05! All reaction types, 20% bonus, instant delivery!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/cheap-dexscreener-reactions" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-green-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-green-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Get Cheap Reactions
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-green-500/20 text-green-300 px-6 py-3 rounded-full font-semibold mb-6">
              💰 Lowest Prices Guaranteed!
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 bg-clip-text text-transparent">
                Cheap Dexscreener Reactions
              </span>
            </h1>
            <div className="flex justify-center items-center gap-4 mb-6">
              <div className="text-6xl">💸</div>
              <div className="bg-green-500/20 border-2 border-green-500 rounded-2xl px-8 py-4">
                <div className="text-5xl md:text-6xl font-bold text-green-400">$0.05</div>
                <div className="text-lg text-gray-300">per reaction</div>
              </div>
              <div className="text-6xl">💸</div>
            </div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              The Most Affordable DexScreener Reaction Service
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Get the best value with our cheap Dexscreener reactions. Same quality, better prices, plus 20% bonus on every order!
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              💰 Get Cheap Reactions Now
            </button>
          </div>
        </section>

        {/* Price Comparison */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Why Our Prices Are the Cheapest
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Compare and see the value yourself
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-800/50 border border-red-500/30 rounded-xl p-6">
                <div className="text-center mb-4">
                  <span className="text-red-400 font-bold">Other Services</span>
                </div>
                <ul className="space-y-3">
                  <li className="flex justify-between text-gray-400">
                    <span>Per Reaction</span>
                    <span className="line-through">$0.10-0.15</span>
                  </li>
                  <li className="flex justify-between text-gray-400">
                    <span>Bonus</span>
                    <span className="line-through">0-5%</span>
                  </li>
                  <li className="flex justify-between text-gray-400">
                    <span>Delivery</span>
                    <span>Slow</span>
                  </li>
                  <li className="flex justify-between text-gray-400">
                    <span>Support</span>
                    <span>Limited</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-green-900/30 to-emerald-900/30 border-2 border-green-500 rounded-xl p-6 transform scale-105">
                <div className="text-center mb-4">
                  <span className="bg-green-500 text-white px-4 py-1 rounded-full font-bold">Dexreaction</span>
                </div>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-300">Per Reaction</span>
                    <span className="text-green-400 font-bold">$0.05</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-300">Bonus</span>
                    <span className="text-green-400 font-bold">+20% FREE</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-300">Delivery</span>
                    <span className="text-green-400 font-bold">Instant</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-300">Support</span>
                    <span className="text-green-400 font-bold">24/7</span>
                  </li>
                </ul>
              </div>
              <div className="bg-slate-800/50 border border-slate-600 rounded-xl p-6">
                <div className="text-center mb-4">
                  <span className="text-gray-400 font-bold">You Save</span>
                </div>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-400">Per Reaction</span>
                    <span className="text-green-400 font-bold">50-67%</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-400">On 1000</span>
                    <span className="text-green-400 font-bold">$50-$100</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-400">Plus Bonus</span>
                    <span className="text-green-400 font-bold">+200 FREE</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-400">Total Value</span>
                    <span className="text-green-400 font-bold">BEST</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Cheap Packages */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Cheap Dexscreener Packages
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Affordable options for every budget
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600, perUnit: 0.042 },
                { qty: 1000, price: 50, total: 1200, perUnit: 0.042, popular: true },
                { qty: 1500, price: 75, total: 1800, perUnit: 0.042 },
                { qty: 2000, price: 100, total: 2400, perUnit: 0.042 }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-green-900/30 to-emerald-900/30 border-2 ${pkg.popular ? 'border-green-500' : 'border-green-500/30'} rounded-xl p-6 hover:border-green-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-4 py-1 rounded-full text-sm font-bold">Best Value</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-2">Reactions</div>
                    <div className="text-4xl font-bold text-green-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-3 mb-4">
                      <div className="text-green-400 font-bold text-lg">Get {pkg.total} total</div>
                      <div className="text-sm text-gray-400">~${pkg.perUnit}/reaction with bonus</div>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Buy Cheap
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 text-center">
              <p className="text-gray-400">💡 With 20% bonus, your effective cost is just <span className="text-green-400 font-bold">$0.042</span> per reaction!</p>
            </div>
          </div>
        </section>

        {/* All Reaction Types Same Price */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              All Reactions - Same Cheap Price
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              No premium pricing for different reactions
            </p>
            <div className="grid md:grid-cols-5 gap-6">
              {[
                { emoji: '🚀', name: 'Rocket', link: '/buy-dexscreener-rockets' },
                { emoji: '🔥', name: 'Fire', link: '/buy-dexscreener-fire' },
                { emoji: '💩', name: 'Poop', link: '/buy-dexscreener-poop' },
                { emoji: '🚩', name: 'Red Flag', link: '/' },
                { emoji: '⭐', name: 'Favorite', link: '/' }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-green-500/20 rounded-xl p-6 text-center hover:border-green-500/50 transition-all cursor-pointer" onClick={() => navigate(item.link)}>
                  <div className="text-5xl mb-3">{item.emoji}</div>
                  <h3 className="font-bold mb-2">{item.name}</h3>
                  <div className="text-2xl font-bold text-green-400">$0.05</div>
                  <div className="text-sm text-gray-400">same price!</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Cheap Doesn't Mean Low Quality */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Cheap Price, Premium Quality
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[
                { icon: '✅', title: 'Real Accounts', desc: 'All reactions delivered through authentic accounts' },
                { icon: '✅', title: 'Natural Patterns', desc: '500 reactions per 10 minutes for organic growth' },
                { icon: '✅', title: 'Instant Start', desc: 'Delivery begins immediately after payment' },
                { icon: '✅', title: '24/7 Service', desc: 'Automated processing around the clock' },
                { icon: '✅', title: 'No Hidden Fees', desc: 'What you see is what you pay' },
                { icon: '✅', title: 'Full Support', desc: 'Help available via web panel and Telegram' }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 bg-slate-800/50 border border-green-500/20 rounded-xl p-6">
                  <div className="text-3xl">{item.icon}</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Cheap Reactions FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'Why are your reactions so cheap?', a: 'We\'ve optimized our operations to offer the best prices. High volume and automated systems allow us to keep costs low while maintaining quality.' },
                { q: 'Are cheap reactions lower quality?', a: 'Absolutely not! Same authentic accounts, same delivery speed, same quality. We just charge less.' },
                { q: 'Is there a catch with cheap pricing?', a: 'No catch! $0.05 per reaction, 20% bonus included, instant delivery. What you see is what you get.' },
                { q: 'Can I get even cheaper rates?', a: 'With the 20% bonus, your effective rate drops to ~$0.042/reaction. That\'s the best value in the market!' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-green-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2 text-green-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Get Cheap Dexscreener Reactions Today!
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Best prices + 20% bonus = Maximum value
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              💰 Get Cheap Reactions Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-green-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-green-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-green-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-green-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default CheapDexscreenerReactions;
